import React, { forwardRef } from "react";
import { BSAnchor } from "../../types";

export const AlertLink = forwardRef<HTMLAnchorElement, BSAnchor>(
  ({ children, className = "", component: Component = "a", ...props }, ref) => (
    <Component {...props} ref={ref} className={`alert-link ${className}`}>
      {children}
    </Component>
  )
);